module Meevo.Components.Common {
  import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;  

  export class MeevoSecureOwned implements angular.IDirective {
    restrict = "A";

    static $inject = [
      "meevo.components.common.SecurityService",
      "meevo.components.common.IdentityService"
    ];

    constructor(private securityService: Meevo.Components.Common.ISecurityService,
      private identityService: Meevo.Components.Common.IIdentityService,
      private $q: ng.IQService) {

    }

  //        let isOwned = scope.ownedLocationId === undefined;
  //isOwned = this.identityService.current().homeLocationId === scope.ownedLocationId;

    link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
      let self = this;

      // Hide the element initially, pending retrieval of the permission
      element.hide();

      let securityKey = null;
      
      // Get the security key via the attribute value. Using $observe so that the value can be a literal or an interpolated string for binding.
      attrs.$observe('meevoSecureOwned', function (item: any) {
        var value = JSON.parse(item);
        securityKey = value.key;

        if (!securityKey) {
          element.show();
          return;
        }

        if (securityKey.toUpperCase().indexOf(Meevo.Components.Common.SecurityParts.KEY_PART_FIELD + ":") >= 0) {
          // Infer the read/write keys for a field
          let readKey = securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
          let writeKey = securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
          // Build the promises
          let readPromise = self.securityService.checkSecurityKey(readKey);
          let writePromise = self.securityService.checkSecurityKey(writeKey);
          let promises = [];
          promises.push(readPromise);
          promises.push(writePromise);
          self.$q.all(promises).then(responses => {
            let readResponse = responses[0];
            let writeResponse = responses[1];
            if (readResponse == SecurityAccessEnum.Deny || readResponse == SecurityAccessEnum.Hide || _.isNull(readResponse) || !value.owned) {
              element.hide();
            } else if (readResponse == SecurityAccessEnum.Grant) {
              element.show();
              if (writeResponse == SecurityAccessEnum.Deny || writeResponse == SecurityAccessEnum.Hide || _.isNull(writeResponse) || !value.owned) {
              
                // TODO: Review issues with disabling.
                // The initial approach of just assigning the disabled property of the element
                // is conflicting with ng-disabled if it is already on the element. This also
                // causes issues with disabling the inner input, select, etc. since ng-disabled already sets
                // up a watcher that can reset the inner disabled after it is assigned here.              
              
                //element.attr("disabled", "true");
                //element.children().attr("disabled", "true");

                // The current approach is to block click input via a div and block keyboard focus via the tabindex
                let blocker = angular.element('<div class="secure-disabled-blocker"></div>');
                let first = element.children().first();

                first.append(blocker);
                // TODO: Determine any other primitives that would need to get tabindex assigned. This blocks the input from receiving focus via tabbing through the form.
                element.find('input, select, textarea').attr("tabindex", "-1");
              }
            }
          });
        } else if (self.keyContainsSpecificPart(securityKey)) { // If the key already has a specific command key-part (READ, WRITE, DELETE, etc.) we check it direclty        
          self.securityService.checkSecurityKey(securityKey).then(result => {
              if (result == SecurityAccessEnum.Deny || result == SecurityAccessEnum.Hide|| !value.owned) {
              element.hide();
            } else {
              element.show();
            }
          });
        } else {
          // Assume a "READ" key for everything else. This keeps it consistent with the structure of all keys to have a permission indicated at the end.
          // We can review this once we actually have all the key data in the DB.
          let readKey = securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
          self.securityService.checkSecurityKey(readKey).then(result => {
              if (result == SecurityAccessEnum.Deny || result == SecurityAccessEnum.Hide || !value.owned) {
              element.hide();
            } else {
              element.show();
            }
          });
        }
      });


    }

    /**
     * Checks if the key already contains a specific permission (like READ, WRITE, DELETE)
     * If a permission is already present the directive will check the security service directly for the key as is without
     * appending anything to it.
     * @param key
     */
    keyContainsSpecificPart(key) {
      let containsPart = false;

      
      let partsToCheck = [Meevo.Components.Common.SecurityParts.KEY_PART_FILTER, Meevo.Components.Common.SecurityParts.KEY_PART_ACTION, Meevo.Components.Common.SecurityParts.KEY_PART_DELETE, Meevo.Components.Common.SecurityParts.KEY_PART_WRITE, Meevo.Components.Common.SecurityParts.KEY_PART_READ];
      _.forEach(partsToCheck, part => {
        if (key.toUpperCase().indexOf(part) >= 0) {
          containsPart = true;
        }
      });

      return containsPart;
    }

    static factory(): angular.IDirectiveFactory {
      let directive = (securityService: Meevo.Components.Common.ISecurityService, identityService: Meevo.Components.Common.IIdentityService, $q: ng.IQService) => {
        return new MeevoSecureOwned(securityService, identityService, $q);
      };
      directive.$inject = ["meevo.components.common.SecurityService", "meevo.components.common.IdentityService", "$q"];
      return directive;
    }
  }

  angular.module("meevo")
    .directive("meevoSecureOwned", MeevoSecureOwned.factory());
}
